import { render, staticRenderFns } from "./AlertGroupOrder.vue?vue&type=template&id=20e7c100&lang=pug&"
import script from "./AlertGroupOrder.vue?vue&type=script&lang=js&"
export * from "./AlertGroupOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports